// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.membersTabularView {
  width: 93%;
  margin: 0 auto;
  padding: 30px 0;
}
.membersTabularView .react-tabs__tab {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #999999;
}
.membersTabularView .react-tabs__tab--selected {
  background: #fff;
  border: 1px solid transparent;
  border-radius: 5px 5px 0 0;
  padding-bottom: 18px;
  border-bottom: 3px solid #075453;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.membersTabularView .react-tabs__tab:focus:after {
  content: none;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/tabularView/membersTabularView.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACR;AAEI;EACI,gBAAA;EACA,6BAAA;EACA,0BAAA;EACA,oBAAA;EACA,gCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,aAAA;AADR","sourcesContent":[".membersTabularView {\n    width: 93%;\n    margin: 0 auto;\n    padding: 30px 0;\n\n    .react-tabs__tab {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #999999;\n    }\n\n    .react-tabs__tab--selected {\n        background: #fff;\n        border: 1px solid transparent;\n        border-radius: 5px 5px 0 0;\n        padding-bottom: 18px;\n        border-bottom: 3px solid #075453;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    .react-tabs__tab:focus:after {\n        content: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
